import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './header-main.css'

const HeaderMain = (props) => {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className={`header-main-container ${props.rootClassName} `}>
      <div
        data-thq="thq-navbar"
        className="header-main-thq-navbar-interactive-elm"
      >
        <Link to="/" className="header-main-navlink10">
          <img
            alt="Arcobo"
            src="/main_logo_arcobo.svg"
            className="header-main-image"
          />
        </Link>
        <div
          data-thq="thq-navbar-nav"
          className="header-main-thq-desktop-menu-elm"
        >
          <nav className="header-main-thq-links-elm">
            <div
              data-thq="thq-dropdown"
              className="header-main-thq-dropdown1 list-item"
            >
              <div
                data-thq="thq-dropdown-toggle"
                className="header-main-thq-dropdown-toggle-elm10 thq-dropdown-toggle-shared"
              >
                <span className="header-main-text10 text_large">Решения</span>
                <div
                  data-thq="thq-dropdown-arrow"
                  className="thq-dropdown-arrow-shared"
                ></div>
              </div>
              <ul
                data-thq="thq-dropdown-list"
                className="header-main-thq-dropdown-list-elm1 thq-dropdown-list-shared"
              >
                <li className="header-main-section-header list-item">
                  <h3 className="header-main-text11">
                    Роботизация производства
                  </h3>
                </li>
                <li className="header-main-thq-dropdown-elm10 list-item">
                  <Link to="/robotic-welding">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm11 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text12 text_medium">
                        Роботизированная сварка
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm11 list-item">
                  <Link to="/palletizing">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm12 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text13 text_medium">
                        Паллетирование и упаковка
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm12 list-item">
                  <Link to="/cnc">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm13 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text14 text_medium">
                        Обслуживание станков ЧПУ
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm13 list-item">
                  <Link to="/custom-robotic">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm14 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text15 text_medium">
                        Специальные робототехнические комплексы
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm14 list-item">
                  <Link to="/kawasaki-robotics">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm15 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text16 text_medium">
                        Промышленные роботы Kawasaki
                      </span>
                    </div>
                  </Link>
                </li>
                <hr className="header-main-separator1"></hr>
                <li className="header-main-section-header list-item">
                  <h3 className="header-main-text17">
                    Сварочные технологии
                  </h3>
                </li>
                <li className="header-main-thq-dropdown-elm15 list-item">
                  <Link to="/welding-monitor">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm16 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text18 text_medium">
                        Мониторинг сварочного производства
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm16 list-item">
                  <Link to="/kolarc">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm17 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text19 text_medium">
                        Сварочные источники Kolarc
                      </span>
                    </div>
                  </Link>
                </li>
                <hr className="header-main-separator2"></hr>
                <li className="header-main-section-header list-item">
                  <h3 className="header-main-text20">
                    Образовательные решения
                  </h3>
                </li>
                <li className="header-main-thq-dropdown-elm17 list-item">
                  <Link to="/education-cells">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm18 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text21 text_medium">
                        Учебные робототехнические комплексы
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm18 list-item">
                  <Link to="/astorino">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm19 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text22 text_medium">
                        Astorino
                      </span>
                    </div>
                  </Link>
                </li>
                <hr className="header-main-separator3"></hr>
                <li className="header-main-thq-dropdown-elm19 list-item">
                  <Link to="/exhibition-robotic">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm20 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text23 text_medium">
                        Выставочные и интерактивные комплексы
                      </span>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
            <div
              data-thq="thq-dropdown"
              className="header-main-thq-dropdown3 list-item"
            >
              <div
                data-thq="thq-dropdown-toggle"
                className="header-main-thq-dropdown-toggle-elm23 thq-dropdown-toggle-shared"
              >
                <span className="header-main-text27 text_large">
                  3D-печать металлом
                </span>
                <div
                  data-thq="thq-dropdown-arrow"
                  className="thq-dropdown-arrow-shared"
                ></div>
              </div>
              <ul
                data-thq="thq-dropdown-list"
                className="header-main-thq-dropdown-list-elm2 thq-dropdown-list-shared"
              >
                <li className="header-main-thq-dropdown-elm22 list-item">
                  <Link to="/producing">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm24 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text28 text_medium">
                        Изготовление металлических деталей
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm23 list-item">
                  <Link to="/repair">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm25 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text29 text_medium">
                        Восстановление и ремонт деталей
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm24 list-item">
                  <Link to="/printers">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm26 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text30 text_medium">
                        3D-принтеры Arcobo
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm25 list-item">
                  <Link to="/materials">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm27 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text31 text_medium">
                        Материалы
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm26 list-item">
                  <Link to="/all-projects">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm28 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text32 text_medium">
                        Реализованные проекты
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm27 list-item">
                  <Link to="/about-waam">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm29 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text33 text_medium">
                        Что такое WAAM?
                      </span>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
            <Link
              to="/all-projects"
              className="header-main-navlink29 text_large"
            >
              Проекты
            </Link>
            <div
              data-thq="thq-dropdown"
              className="header-main-thq-dropdown4 list-item"
            >
              <div
                data-thq="thq-dropdown-toggle"
                className="header-main-thq-dropdown-toggle-elm30 thq-dropdown-toggle-shared"
              >
                <span className="header-main-text34 text_large">
                  О компании
                </span>
                <div
                  data-thq="thq-dropdown-arrow"
                  className="thq-dropdown-arrow-shared"
                ></div>
              </div>
              <ul
                data-thq="thq-dropdown-list"
                className="header-main-thq-dropdown-list-elm3 thq-dropdown-list-shared"
              >
                <li className="header-main-thq-dropdown-elm28 list-item">
                  <Link to="/company">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm31 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text35 text_medium">
                        О компании
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm29 list-item">
                  <Link to="/manufacture">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm32 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text36 text_medium">
                        Производство
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm30 list-item">
                  <Link to="/partners">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm33 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text37 text_medium">
                        Партнеры
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm31 list-item">
                  <Link to="/founders">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm34 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text38 text_medium">
                        Основатели
                      </span>
                    </div>
                  </Link>
                </li>
                <li className="header-main-thq-dropdown-elm31 list-item">
                  <Link to="/service">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="header-main-thq-dropdown-toggle-elm34 thq-dropdown-toggle-shared"
                    >
                      <span className="header-main-text38 text_medium">
                        Сервис и поддержка
                      </span>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
            <Link to="/contacts" className="header-main-navlink34 text_large">
              Контакты
            </Link>
          </nav>
        </div>
        <button
          type="button"
          className="header-main-thq-burger-menu-elm"
          aria-label="Открыть меню"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span className="header-main-burger-bar"></span>
          <span className="header-main-burger-bar"></span>
          <span className="header-main-burger-bar"></span>
        </button>
        {menuOpen && (
          <div className="header-main-thq-mobile-menu-elm">
            <nav className="header-main-mobile-nav">
              <Link to="/robotic-welding" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Роботизированная сварка</Link>
              <Link to="/palletizing" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Паллетирование и упаковка</Link>
              <Link to="/cnc" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Обслуживание станков ЧПУ</Link>
              <Link to="/custom-robotic" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Специальные робототехнические комплексы</Link>
              <Link to="/kawasaki-robotics" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Промышленные роботы Kawasaki</Link>
              <Link to="/welding-monitor" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Мониторинг сварочного производства</Link>
              <Link to="/kolarc" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Сварочные источники Kolarc</Link>
              <Link to="/education-cells" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Учебные робототехнические комплексы</Link>
              <Link to="/astorino" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Astorino</Link>
              <Link to="/exhibition-robotic" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Выставочные и интерактивные комплексы</Link>
              <Link to="/producing" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Изготовление металлических деталей</Link>
              <Link to="/repair" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Восстановление и ремонт деталей</Link>
              <Link to="/printers" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>3D-принтеры Arcobo</Link>
              <Link to="/materials" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Материалы</Link>
              <Link to="/all-projects" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Реализованные проекты</Link>
              <Link to="/about-waam" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Что такое WAAM?</Link>
              <Link to="/all-projects" className="header-main-mobile-link text_large" onClick={() => setMenuOpen(false)}>Проекты</Link>
              <Link to="/company" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>О компании</Link>
              <Link to="/manufacture" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Производство</Link>
              <Link to="/partners" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Партнеры</Link>
              <Link to="/founders" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Основатели</Link>
              <Link to="/service" className="header-main-mobile-link text_medium" onClick={() => setMenuOpen(false)}>Сервис и поддержка</Link>
              <Link to="/contacts" className="header-main-mobile-link text_large" onClick={() => setMenuOpen(false)}>Контакты</Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  )
}

HeaderMain.defaultProps = {
  rootClassName: '',
}

HeaderMain.propTypes = {
  rootClassName: PropTypes.string,
}

export default HeaderMain
